const INVISIBLE_CHARACTERS_SET = new Set([
  '\u00a0',
  '\u00ad',
  '\u034f',
  '\u061c',
  '\u115f',
  '\u1160',
  '\u17b4',
  '\u17b5',
  '\u180e',
  '\u2000',
  '\u2001',
  '\u2002',
  '\u2003',
  '\u2004',
  '\u2005',
  '\u2006',
  '\u2007',
  '\u2008',
  '\u2009',
  '\u200a',
  '\u200b',
  '\u200c',
  '\u200d',
  '\u200e',
  '\u200f',
  '\u202f',
  '\u205f',
  '\u2060',
  '\u2061',
  '\u2062',
  '\u2063',
  '\u2064',
  '\u206a',
  '\u206b',
  '\u206c',
  '\u206d',
  '\u206e',
  '\u206f',
  '\u3000',
  '\u2800',
  '\u3164',
  '\ufeff',
  '\uffa0',
  '\u{0001d159}',
  '\u{0001d173}',
  '\u{0001d174}',
  '\u{0001d175}',
  '\u{0001d176}',
  '\u{0001d177}',
  '\u{0001d178}',
  '\u{0001d179}',
  '\u{0001d17a}',
]);

const regEx = new RegExp(
  `[${Array.from(INVISIBLE_CHARACTERS_SET).join('')}]`,
  'gu'
);

// VULN-1028235 pointed out that invisble characters can be used to make the
// actual file name different than the visual appearance of that name. In order
// to prevent invisible characters leading to exploits, we strip most of it,
// except for the non-breaking space which has a convenient HTML entity.
export const ReplaceInvisibleCharactersMarkdown = (html: string) => {
  return html.replace(regEx, function (match: string) {
    if (match === '\u00a0') {
      return '&nbsp;';
    }
    return '';
  });
};
